import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Flex } from "antd"
import BookingTag from "../../../BookingTag"
import styles from "../../index.module.css"

const ReservationSummaryCard = ({ reservation }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.card}>
      <Flex align="center" justify="space-between" className={styles.cardHeader}>
        <span className={styles.cardTitle}>{t("booking.reservation_detail.summary_title")}</span>
        <BookingTag color="success">{reservation.status}</BookingTag>
      </Flex>
      <div className={styles.summaryGrid}>
        <span className={styles.summaryKey}>{t("booking.reservation_detail.reservation_id")}</span>
        <span className={styles.summaryVal}>#{reservation.reservationNumber}</span>
        <span className={styles.summaryKey}>{t("booking.reservation_detail.source")}</span>
        <span className={styles.summaryVal}>{reservation.source}</span>
        <span className={styles.summaryKey}>{t("booking.reservation_detail.created")}</span>
        <span className={styles.summaryVal}>{reservation.created}</span>
        {/* <span className={styles.summaryKey}>{t("booking.reservation_detail.cancellation_policy")}</span>
        <span className={styles.summaryVal}>{reservation.cancellationPolicy ?? "-"}</span> */}
      </div>
    </div>
  )
}

ReservationSummaryCard.propTypes = {
  reservation: PropTypes.object.isRequired
}

export default ReservationSummaryCard
